function Sliderinitialize()
{
var sliderSpeed = $( '.testimonial-slider' ).attr( "data-speed" );
var sliderSpeedInt = parseInt( sliderSpeed );
    
    $( '.testimonial-slider' ).slick({
        dots: false,
        infinite: true,
        arrows: true,
        speed: 300,
        autoplay: true,
        autoplaySpeed: sliderSpeedInt,
        slidesToShow: 3,
        slidesToScroll: 1,
        adaptiveHeight: true,
        cssEase: 'linear',
        prevArrow:  '<span type="button" class="arrow slick-prev"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="40" height="40" viewBox="0 0 20 20">' +
        '<path fill="#C1BCBC" d="M14 20c0.128 0 0.256-0.049 0.354-0.146 0.195-0.195 0.195-0.512 0-0.707l-8.646-8.646 8.646-8.646c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-9 9c-0.195 0.195-0.195 0.512 0 0.707l9 9c0.098 0.098 0.226 0.146 0.354 0.146z"/>' +
        '</svg></span>',
        nextArrow:  '<span type="button" class="arrow slick-next"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="40" height="40" viewBox="0 0 20 20">' +
        '<path fill="#C1BCBC" d="M5 20c-0.128 0-0.256-0.049-0.354-0.146-0.195-0.195-0.195-0.512 0-0.707l8.646-8.646-8.646-8.646c-0.195-0.195-0.195-0.512 0-0.707s0.512-0.195 0.707 0l9 9c0.195 0.195 0.195 0.512 0 0.707l-9 9c-0.098 0.098-0.226 0.146-0.354 0.146z"/>' +
        '</svg></span>',
        responsive: 
        [
            {
                breakpoint: 1024,
                settings: 
                {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 750,
                settings: 
                {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
            
        ]
      });
}

window.addEventListener( "load", function( e )
{ 
    Sliderinitialize();
} );